import React, { Component } from 'react';
import $ from 'jquery';
import '../css/dataTables.css';


class QueryPreviewModal extends Component {
    
    

    closeQuery= async () => {
        $('#queryPreview').modal('hide');
    };

    
 renderQueryHeader = () => {
    return(
            <div className="tab-content" >
                <div className="card" style={{background: 'transparent'}}>
                    <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <br></br>
                            <textarea
                            type="text"
                            className=" form-control btn-outline-secondary"
                            id="txtComments"
                            rows="2"
                            cols="100"
                            style={{backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            />
                        </div>     
                    </div>   
                       
                    </div>
                </div>
                <br/>
            </div>
      
            
    )
};
renderQueryBody = () => {
    return(
        
        <div className="tab-content" >
            <div className="card" style={{background: 'transparent'}}>
                <div className="card-body">
                         <div className="col-md-12 col-sm-12">
                            {/* {this.renderTable()} */}
                            </div>
                </div>
            </div>
        </div> 
    )
};    

   
    render() {
   
       
        return (
            <div className="modal fade bd-example-modal-lg bgtransparent" id="queryPreview" style={{zIndex:91}} role="dialog"
             aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-lg " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">Vista Previa de Consulta</h4>
                            <button type="button" className="close" onClick={this.closeQuery}  aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row">
                                    <div className="col-md-12">{this.renderQueryHeader()}</div>
                                    <div className="col-md-12">{this.renderQueryBody()}</div>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <br/>
                        <br/>
                        <div className="modal-footer">
                        <button type="button" className="btn botonCerrar text-white" onClick={this.closeQuery} >Ejecutar</button>
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeQuery} >Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default QueryPreviewModal;